import Nip05 from '@/components/Nip05'
import UserAvatar from '@/components/UserAvatar'
import Username from '@/components/Username'
import { useFetchProfile } from '@/hooks/useFetchProfile'
import { ReactNode } from 'react'

export default function ProfileRow({
  pubkey,
  showAbout = false,
  actions
}: {
  pubkey: string
  showAbout?: boolean
  actions?: ReactNode
}) {
  const { profile } = useFetchProfile(pubkey)

  return (
    <div className="flex gap-2 items-start">
      <UserAvatar user={pubkey} className="shrink-0" />
      <div className="w-full overflow-hidden">
        <Username
          user={pubkey}
          className="font-semibold truncate max-w-full w-fit"
          skeletonClassName="h-4"
        />
        <Nip05 user={pubkey} />
        {showAbout && profile?.metadata?.about && (
          <div className="truncate text-muted-foreground text-sm">{profile.metadata.about}</div>
        )}
      </div>
      {actions && <div className="flex gap-2 items-center shrink-0">{actions}</div>}
    </div>
  )
}
